// Keep sitemap cache windows and size limits in shared config so both app and API
// code can import from a single source of truth.
export const PUBLICATION = "BeritaHarian";
export const PUBLICATION_INDEX = "beritaharian";
export const LANGUAGE = "ms";
export const DEFAULT_SIZE_COUNT = 1000;
export const OLDEST_ARCHIVE_YEAR = 2015;
export const ARCHIVE_PAGE_SIZE = 100;
export const AUTHOR_AGG_SIZE = 1000;

export const MAX_AGE_MONTHLY = 2592000; // 30 days in seconds
export const MAX_AGE_DAILY = 86400; // 1 day in seconds
export const MAX_AGE_HOURLY = 3600; // 1 hour in seconds

// CaaS _source field lists — each sitemap requests only the fields it needs
export const ARCHIVE_CAAS_SOURCE = [
  "data.context.urlPath",
  "data.context.updated",
  "data.context.edited",
  "data.context.lastmodified",
];

export const SECTION_SITEMAP_SOURCE = [
  "data.context.updated",
  "data.context.edited",
];

export const GOOGLE_NEWS_FIELDS = [
  "data.context.urlPath",
  "data.context.edited",
  "data.context.updated",
  "data.context.title",
];

export const GOOGLE_NEWS_SOURCE = [
  ...GOOGLE_NEWS_FIELDS,
  "data.context.id",
  "data.context.elements",
  "data.context.ogImages",
];

// Error messages
export const AUTHOR_SITEMAP_ERROR_MESSAGE = "Error generating author sitemap";
